export const EVENT_CARD_LIMITS_UPDATE_SUCCESS = 'cardLimits.updateSuccess'
export const EVENT_CARD_LIMITS_UPDATE_ERROR = 'cardLimits.updateError'
